// extracted by mini-css-extract-plugin
module.exports = {"carregador":"Carregador_carregador__2-e_m","icone":"Carregador_icone__fV0vj","small":"Carregador_small__QAtng"};